import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { ValidacaoScrRoutingModule } from './validacao-scr-routing.module';
import { ValidacaoScrPesquisaComponent } from './validacao-scr-pesquisa.component';
import { ValidacaoScrListagemComponent } from './validacao-scr-listagem.component';
import { ValidacaoScrDetalheComponent } from './validacao-scr-detalhe.component';

@NgModule({
  imports: [
    SharedModule,
    ValidacaoScrRoutingModule
  ],
  exports: [
    ValidacaoScrListagemComponent
  ],
  declarations: [
    ValidacaoScrPesquisaComponent,
    ValidacaoScrListagemComponent,
    ValidacaoScrDetalheComponent
  ],
  providers: [ 
    DatePipe
  ]
})
export class ValidacaoScrModule { }
